export const ROLE = 'ROLE';
export const REGISTER = 'REGISTER';
export const LOGIN = 'LOGIN';
export const APPLICANT = 'APPLICANT';
export const NID = 'NID';
export const EMAIL = 'EMAIL';
export const PHONE = 'PHONE';
export const NID_CHECK_MARITAL = 'NID_CHECK_MARITAL';
export const FIND_ACCOUNT = 'FIND_ACCOUNT';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const CONFIRM_ACCOUNT = 'CONFIRM_ACCOUNT';
export const DISTRICT = 'DISTRICT';
export const HOUSE_CATEGORY = 'HOUSE_CATEGORY';
export const HOUSE_RANGE = 'HOUSE_RANGE';
export const BANKS = 'BANKS';
export const APPLICATION = 'APPLICATION';
export const UPI = 'UPI';
export const LOAN = 'LOAN';
export const MY_LOAN = 'MY_LOAN';
export const USERS = 'USERS';
export const RESEND_EMAIL = 'RESEND_EMAIL';
export const LOANS_APPLICATIONS = 'LOANS_APPLICATIONS';
export const BANK_STATS = 'BANK_STATS';
export const SPECIFIC_LOAN_APPLICATION = 'SPECIFIC_LOAN_APPLICATION';
export const CERTIFICATE = 'CERTIFICATE';
export const ZIP_CERTIFICATE = 'ZIP_CERTIFICATE';
export const COMMENT_APPLICATION = 'COMMENT_APPLICATION';
export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
export const CLEAR_NEW_NOTIFICATIONS = 'CLEAR_NEW_NOTIFICATIONS';
export const FETCH_UNSEEN_NOTIFICATIONS_SUCCESS = 'FETCH_UNSEEN_NOTIFICATIONS_SUCCESS';
export const MARK_NOTIFICATIONS_AS_SEEN = 'MARK_NOTIFICATIONS_AS_SEEN';
export const MARK_NOTIFICATION_AS_SEEN = 'MARK_NOTIFICATION_AS_SEEN';
